// extracted by mini-css-extract-plugin
export default {"wrapper":"_ce33e64c","content":"_eb03acd6"};